import PropTypes from 'prop-types';
import React from 'react';

function Icon({ size = 24, viewBox = '0 0 24 24', ...props }) {
  return (
    <svg
      fill="currentColor"
      height={size}
      width={size}
      viewBox={viewBox}
      {...props}
    />
  );
}

Icon.propTypes = {
  size: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  viewBox: PropTypes.string,
};

export default React.memo(Icon);
